export default function GiftsSection() {
  return (
    <section className="py-10 md:py-14 bg-[#faf8f5]">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#0f3d32] to-[#1a6b5a] px-6 py-8 md:px-10 md:py-10">
          {/* Декоративные круги */}
          <div className="absolute -top-10 -right-10 w-48 h-48 bg-[#e8a030]/10 rounded-full pointer-events-none"></div>
          <div className="absolute -bottom-8 right-24 w-32 h-32 bg-white/5 rounded-full pointer-events-none"></div>

          <div className="relative z-10 flex flex-col sm:flex-row items-start sm:items-center gap-6 md:gap-8">

            {/* Лого WB */}
            <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 flex items-center justify-center rounded-2xl overflow-hidden bg-white/10 border border-white/20">
              <img
                src="/img/gifts-wildberries.png"
                alt="Wildberries"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Текст */}
            <div className="flex-1 min-w-0">
              <div className="flex flex-wrap items-center gap-3 mb-3">
                <h3 className="text-xl md:text-2xl font-extrabold text-white leading-tight">
                  Подарки участникам
                </h3>
                <span className="inline-block bg-[#e8a030] text-white text-sm font-extrabold px-3 py-1 rounded-full whitespace-nowrap">
                  до 5 000 ₽
                </span>
              </div>
              <p className="text-base md:text-lg text-white/80 leading-relaxed mb-1">
                Сертификаты ВБ до 5 000 руб. самым преданным участникам.
              </p>
              <p className="text-sm md:text-base text-white/65 leading-relaxed">
                Придите и зарегистрируйтесь до начала мероприятия{' '}
                <span className="font-bold text-white/90">16.04 в 9:30</span> и{' '}
                <span className="font-bold text-white/90">17.04 в 10:00</span>{' '}
                — и в конце получите подарок!
              </p>
            </div>

            {/* Ссылка */}
            <a
              href="/vb.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-shrink-0 inline-flex items-center gap-2 bg-[#e8a030] hover:bg-[#f0aa35] text-white font-bold text-sm px-6 py-3 rounded-full transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
              style={{ boxShadow: '0 4px 20px 0 rgba(232,160,48,0.4)' }}
            >
              Подробнее
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
